// Step 22 — buyer identity card.
//
// Reads only fields the backend already returns (`intel.acquirer` +
// `intel.contact`). Never invents type/category/thesis when the row
// doesn't have it — those fields simply don't render.

import { AISection } from "../AIPrimitives";

export default function AIBuyerIdentityCard({ intel }) {
  const acq = intel?.acquirer;
  const contact = intel?.contact;
  if (!acq) return null;

  const rows = [];
  if (acq.country) rows.push(["Land", acq.country]);
  if (acq.org_number) rows.push(["Org.nr", acq.org_number]);
  if (contact?.name) {
    const contactBits = [contact.name];
    if (contact.title) contactBits.push(contact.title);
    rows.push(["Senaste kontakt", contactBits.join(" · ")]);
    if (contact.email) rows.push(["Kontakt-e-post", contact.email]);
  }

  return (
    <AISection title="Identitet">
      <div className="qai-buyer-identity">
        <div className="qai-buyer-identity-name">{acq.name}</div>
        {rows.length === 0 ? (
          <div className="qai-shell-empty-hint">
            Endast namn finns registrerat för denna köpare.
          </div>
        ) : (
          <dl className="qai-buyer-identity-facts">
            {rows.map(([k, v]) => (
              <div key={k} className="qai-buyer-identity-row">
                <dt>{k}</dt>
                <dd>{v}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </AISection>
  );
}
